import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

const FAQS = [
  {
    q: "How many eye patches are included?",
    a: "Each pack contains 60 hydrogel eye patches (30 pairs) — enough for a full month of daily rituals.",
  },
  {
    q: "How do I use the eye patches?",
    a: "Start with a clean, dry face. Apply one patch beneath each eye, relax for 15–20 minutes, then remove and gently massage the remaining serum into the skin. No rinsing needed.",
  },
  {
    q: "How long should I wear them?",
    a: "We recommend 15–20 minutes per session — long enough to enjoy the cooling sensation while the serum absorbs.",
  },
  {
    q: "Can I use them every day?",
    a: "Yes — they are gentle enough for daily use, morning or evening. Many customers keep the jar in the fridge for an extra-cooling treat.",
  },
  {
    q: "What ingredients are included?",
    a: "The hydrogel serum features 24K gold, collagen, hyaluronic acid, vitamin C, aloe vera and ceramides, among other skin-loving ingredients. The full list appears on the packaging.",
  },
  {
    q: "What is the difference between the one-time purchase and subscription?",
    a: "The one-time purchase (£19.99) is a single pack delivered once. Subscribe & Save (£14.99/month) delivers a fresh pack every month at a 25% saving.",
  },
  {
    q: "How does the subscription work?",
    a: "You are billed £14.99 each month and a fresh 60-patch pack is sent to you regularly. Your payment details are handled securely at checkout, and each renewal is automatic until you cancel.",
  },
  {
    q: "How can I cancel my subscription?",
    a: "You can cancel at any time in line with our subscription terms — simply contact us at hello@aliver.co.uk and we will take care of it. No long commitments.",
  },
];

export const Faq = () => (
  <section id="faq" className="py-24 md:py-32" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-5 sm:px-8">
      <SectionHeading
        align="center"
        eyebrow="Good To Know"
        title={<>Questions, <span className="italic gold-text">answered</span></>}
      />
      <Reveal delay={0.12}>
        <Accordion type="single" collapsible className="mt-14" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-champagne/80">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="text-left font-display text-xl md:text-2xl text-ink hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#5C5C5C] leading-relaxed pb-6" data-testid={`faq-answer-${i}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
